const collectionDatasetActions = {
  ADD_COLLECTION_DATASET_ERROR: 'ADD_COLLECTION_DATASET_ERROR',
  ADD_COLLECTION_DATASETS: 'ADD_COLLECTION_DATASETS',
  ADD_COLLECTION_DATASETS_ASSIGNABLE: 'ADD_COLLECTION_DATASETS_ASSIGNABLE',
  ADD_COLLECTION_DATASETS_SUCCESS: 'ADD_COLLECTION_DATASETS_SUCCESS',
  FETCH_COLLECTION_DATASETS: 'FETCH_COLLECTION_DATASETS',
  FETCH_COLLECTION_DATASETS_ASSIGNABLE: 'FETCH_COLLECTION_DATASETS_ASSIGNABLE',
  FETCH_COLLECTION_DATASETS_ASSIGNABLE_ERROR: 'FETCH_COLLECTION_DATASETS_ASSIGNABLE_ERROR',
  FETCH_COLLECTION_DATASETS_ASSIGNABLE_SUCCESS: 'FETCH_COLLECTION_DATASETS_ASSIGNABLE_SUCCESS',
  HIDE_ADD_COLLECTION_DATASETS: 'HIDE_ADD_COLLECTION_DATASETS',
  REMOVE_COLLECTION_DATASET_ASSIGNABLE: 'REMOVE_COLLECTION_DATASET_ASSIGNABLE',
  REMOVE_COLLECTION_DATASETS: 'REMOVE_COLLECTION_DATASETS',
  REMOVE_COLLECTION_DATASETS_ERROR: 'REMOVE_COLLECTION_DATASETS_ERROR',
  REMOVE_COLLECTION_DATASETS_SUCCESS: 'REMOVE_COLLECTION_DATASETS_SUCCESS',
  SHOW_ADD_COLLECTION_DATASETS: 'SHOW_ADD_COLLECTION_DATASETS',
  SHOW_COLLECTION_DATASETS_ERROR: 'SHOW_COLLECTION_DATASETS_ERROR',
  SHOW_COLLECTION_DATASETS_RESULTS: 'SHOW_COLLECTION_DATASETS_RESULTS',
  TOGGLE_COLLECTION_DATASET_COLUMN_ORDER_BY: 'TOGGLE_COLLECTION_DATASET_COLUMN_ORDER_BY',
  TOGGLE_COLLECTION_DATASET_SELECTED: 'TOGGLE_COLLECTION_DATASET_SELECTED',
  TOGGLE_COLLECTION_DATASET_SINGLE_SORTING: 'TOGGLE_COLLECTION_DATASET_SINGLE_SORTING',
  TOGGLE_COLLECTION_DATASETS_SELECTED: 'TOGGLE_COLLECTION_DATASETS_SELECTED',
  UPDATE_COLLECTION_DATASETS_ASSIGNABLE_PROPERTIES: 'UPDATE_COLLECTION_DATASETS_ASSIGNABLE_PROPERTIES',
  UPDATE_COLLECTION_DATASETS_FILTER: 'UPDATE_COLLECTION_DATASETS_FILTER',
  UPDATE_COLLECTION_DATASETS_FLAGS: 'UPDATE_COLLECTION_DATASETS_FLAGS',
  UPDATE_COLLECTION_UNASSIGNED_DATASETS_PROPERTIES: 'UPDATE_COLLECTION_UNASSIGNED_DATASETS_PROPERTIES',
};

export default collectionDatasetActions;
